// extracted by mini-css-extract-plugin
export default {"container":"rm_container__gbMQ9","rm":"rm_rm__zcBul"};